import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-ocr-autoverify-result',
  templateUrl: './ocr-autoverify-result.component.html',
  styleUrls: ['./ocr-autoverify-result.component.css']
})
export class OcrAutoverifyResultComponent implements OnInit {

  @Input() autoVerifyData: any;
  @Input() docType: string;
  @Input() employeeId: any;

  autoVerifyForm: FormGroup;

  licence: any

  pan: any;

  proofUrl: string;

  constructor(private fb: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    if (this.autoVerifyData && this.docType === 'dl') {
      this.licence = this.autoVerifyData.data;
      this.proofUrl = "https://instaveritas-files-dev.s3.ap-southeast-1.amazonaws.com/public/uploads/dl/images/" + this.licence.screenshot;
    }

    if (this.autoVerifyData && this.docType === 'pan') {
      this.pan = this.autoVerifyData.result;
    }


  }

  initForm() {

    this.autoVerifyForm = this.fb.group({

    });

  }


  navigateToAddressPage() {



    const navigationExtras: NavigationExtras = {
      queryParams: {employeeId: this.employeeId.toString()},
    };

    this.router.navigate([ this.activatedRoute.snapshot.url.join('/') + '/address'], navigationExtras);
  }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/ocr/ocr-autoverify-result/ocr-autoverify-result.component.ts